/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React from "react";
import { View } from "react-native";
import Icon from "react-icons-kit";
import { dashboard } from "react-icons-kit/fa/dashboard";

import { useDispatch, useSelector } from "react-redux";
import { ActionCreators } from "actions";
import { RootState, FullDataQueryType } from "store/types";

import { Text } from "UpduoLibrary";
import { formattedDuration } from "config/Utilities";
import { skaleWebTextLightGray } from "config/UpduoColors";
import GraphTab from "./GraphTab";

export default function GraphTabGroup() {
  const dispatch = useDispatch();
  const fullDataQueryType = useSelector(
    (state: RootState) => state.fullDataQueryType
  );
  const timeSeriesData = useSelector(
    (state: RootState) => state.timeSeriesData
  );

  const _handleSetQueryType = (newQueryType: FullDataQueryType) => {
    dispatch(ActionCreators.setFullDataQueryType(newQueryType));
  };

  const durationCurrent = formattedDuration(
    timeSeriesData.duration.overall_value
  );

  return (
    <View
      style={{
        flexDirection: "column",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          paddingLeft: 3,
          marginTop: 8,
          marginBottom: -3,
        }}
      >
        <div
          style={{
            color: skaleWebTextLightGray,
            paddingBottom: 3.5,
          }}
        >
          <Icon size={10} icon={dashboard} />
        </div>
        <View style={{ width: 3 }} />
        <Text style={{ color: skaleWebTextLightGray, fontSize: 10 }}>
          {"Stats"}
        </Text>
      </View>
      <GraphTab
        isFirst={true}
        label={"USER SESSIONS"}
        sublabel={"CREDITED"}
        value={
          timeSeriesData.session_count
            ? timeSeriesData.session_count.overall_value.toLocaleString()
            : 0
        }
        isActive={fullDataQueryType === "session_count"}
        onPress={() => {
          _handleSetQueryType("session_count");
        }}
      />
      <GraphTab
        label={"DURATION"}
        sublabel={"CREDITED"}
        value={durationCurrent[0]}
        isActive={fullDataQueryType === "duration"}
        onPress={() => {
          _handleSetQueryType("duration");
        }}
        durationUnit={durationCurrent[1]}
      />
    </View>
  );
}
